'use client'

import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import { useFetch } from '@marketplace-web/shared/api-client'
import { setLocalStorageItem } from '@marketplace-web/shared/browser'
import { useTracking } from '@marketplace-web/shared/event-tracker'
import { useSession } from '@marketplace-web/shared/session'

import { continueConversationClicked } from '_libs/common/event-tracker/events'
import { getFeedbackType } from 'components/AutomatedResponseFeedbackModal/utils'
import {
  CURRENT_SURVEY_VERSION,
  DENY_AUTOMATED_SUPPORT_FEEDBACK,
} from 'constants/automated-feedback'
import {
  getIsAutomatedSupportFeedbackEnabled,
  requestFurtherHelp,
} from '@marketplace-web/domain/conversation-feedback-data'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'
import useHelpCenterSessionTracking from 'hooks/useHelpCenterSessionTracking'

const DenyAutomatedSupportFeedback = ({
  primary,
  title,
  inverse,
  theme,
  size,
  action,
}: Partial<ConversationActionProps>) => {
  const { fetch, isLoading: isFetchFeedbackEnabledLoading } = useFetch(
    getIsAutomatedSupportFeedbackEnabled,
  )

  const userId = useSession().user?.id
  const { conversation } = useConversationContext()
  const conversationId = conversation?.id
  const { helpCenterSessionId } = useHelpCenterSessionTracking()
  const { track } = useTracking()

  async function handleButtonClick() {
    if (!userId || !conversationId || !helpCenterSessionId) return

    track(
      continueConversationClicked({
        threadId: conversationId?.toString(),
        helpCenterSessionId,
        supportType: getFeedbackType(action),
      }),
    )

    const response = await fetch({
      userId,
      surveyVersion: CURRENT_SURVEY_VERSION,
      conversationId: conversationId.toString(),
    })

    if (response.data?.enabled) {
      setLocalStorageItem(DENY_AUTOMATED_SUPPORT_FEEDBACK, conversationId.toString())
    }

    await requestFurtherHelp({
      userId,
      conversationId: conversationId.toString(),
      helpCenterSessionId,
    })
  }

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleButtonClick}
      isLoading={isFetchFeedbackEnabledLoading}
    />
  )
}

export default DenyAutomatedSupportFeedback
